import { createContext } from 'react'

interface ResponseContext {
  setStatusCode: (status: number) => void
}

export const ResponseContext = createContext<ResponseContext>({
  setStatusCode: (() => {}) as any,
})
